import { cn } from "@/core/utils";
import type { ReactNode } from "react";
import { wobaText } from "./typography";

type DashboardSectionProps = {
  title: ReactNode;
  /** Ação à direita do título (ex.: SegmentControl de Meus produtos). */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
};

/** Seção do Painel: título Heading/Small + conteúdo com gap de 16px (Figma 6036:2726). */
export function DashboardSection({
  title,
  action,
  children,
  className,
  "data-testid": testId,
}: DashboardSectionProps) {
  return (
    <section
      className={cn("flex flex-col gap-4 w-full min-w-0", className)}
      data-testid={testId}
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        <h2 className="flex-1 min-w-0" style={wobaText.headingSmall}>
          {title}
        </h2>
        {action}
      </div>
      {children}
    </section>
  );
}
